import $ from 'jquery'
import {escapeHtmlSymbols} from "../../atUtils"
import {atImgPath} from "../../atBrowserUtils"
import TemplateView from "../../TemplateView"
import NamesCell from "./NamesCell"
import CustomerStore from "../../store/CustomerStore"
import ProjectStore from "../../store/ProjectStore"
import TaskStore from "../../store/TaskStore"
import TaskSelectionLabel from "../TaskSelectionLabel"
import {DateFormat} from "../../date_format"
import TaskManagementDeadlineEditor from "../DeadlineEditor"
import TaskStatusButton from "../../controls/task/TaskStatusButton"
import {selectFakeStatusIdByTaskComplete} from '../../workflowStatus/selectors'
import {unsafe_selectWithState} from "../../redux/utils"
import {getTypeOfWork} from "../../entities/selectors"
import TypeOfWorkButton from "../../controls/task/TypeOfWorkButton"
import TimeEditor from '../../controls/task/TimeEditor'
import messageResource from '../../messageResource'
import {setEventPreventHidingEditTaskSlidingPanel} from '../../panels/utils'
import {TaskSortBy} from '../constants'
import {isESTEnabled, isTWSEnabled} from '../../features/selectors'
import DatePickerMenu from '../../controls/dateControls/DatePickerMenu'
import CorporateScheduleCalculator from '../../controls/dateControls/CorporateScheduleCalculator'

const dateFormat = new DateFormat(window.SystemSettings.dateFormat)

export default class TaskRow extends TemplateView {
    constructor({
        taskId = 0,
        tokensHighlighter = null,
        openTaskPanel = (id) => {},
        typeOfWorkMenu =  null,
        taskStatusMenu =  null,
    }) {
        super()
        this.taskId = taskId
        this.tokensHighlighter = tokensHighlighter
        this.typeOfWorkMenu = typeOfWorkMenu
        this.taskStatusMenu = taskStatusMenu

        this.actions = {
            openTaskPanel,
        }

        this.state = {
            canEdit: false,
            canEditTypeOfWork: false,
            canReopenProject: false,
            selectable: false,
            singleCPSelection: {},

            editable: false,
            taskName: "",
            projectName: "",
            customerName: "",
            workflowStatusId: 0,
            completed: false,
            typeOfWorkId: -1,
            estimatedTime: null,
            spentTime: 0,
            deadline: null,
            lastTrackingDate: null,
            creationDate: null,
            commentsNumber: 0,

            isESTEnabled: false,
            isBTYEnabled: false,
            isTWSEnabled: false,

            columnsOrder: [],
        }


        this.onStatePropertyChanged('taskName', (name) => {
            this.namesCell.setState({
                taskName: name,
            })
        })

        this.onStatePropertyChanged('commentsNumber', (commentsNumber) => {
            this.namesCell.setState({
                commentsNumber: commentsNumber,
            })
        })

        this.onAnyStatePropertyChanged(['customerName', 'projectName', 'singleCPSelection'], () => {
            this.namesCell.setState({
                customerName: !this.state.singleCPSelection.customerId ? this.state.customerName : '',
                projectName: !this.state.singleCPSelection.projectId ? this.state.projectName : '',
            })
        })

        this.onAnyStatePropertyChanged(['workflowStatusId', 'completed', 'isTWSEnabled'], () => {
            const isTWSEnabled = this.state.isTWSEnabled
            this.statusButton.setState({
                statusId: isTWSEnabled ? this.state.workflowStatusId : selectFakeStatusIdByTaskComplete(this.state.completed)
            })
        })

        this.onAnyStatePropertyChanged(['typeOfWorkId', 'isBTYEnabled'], ({typeOfWorkId, isBTYEnabled}) => {
            if (isBTYEnabled)
                this._updateTypeOfWork(typeOfWorkId)
        })

        this.onStatePropertyChanged('estimatedTime', (estimate) => {
            this.estimateEditor.setTime(estimate)
        })

        this.onStatePropertyChanged('spentTime', (time) => {
            this.spentTimeCell.setTime(time)
        })

        this.onStatePropertyChanged('deadline', (deadline) => {
            this.deadlineEditor.setDeadline(deadline)
        })

        this.onStatePropertyChanged('lastTrackingDate', (date) => {
            this.$lastTrackingDate.text(date ? dateFormat.formatDate(date) : "")
            this.$el.toggleClass("noLastTrackingDate", !date)
        })

        this.onStatePropertyChanged('creationDate', (date) => {
            this.$creationDate.text(date ? dateFormat.formatDate(date) : "")
        })

        this.onStatePropertyChanged('canEdit', (canEdit) => {
            this.taskSelectionLabel.setDisabled(!canEdit)
            this.setEditable(canEdit)
        })

        this.onStatePropertyChanged('canEditTypeOfWork', (canEdit) => {
            this.typeOfWorkEditor.setState({editable: canEdit})
        })

        this.onStatePropertyChanged('selectable', (selectable) => {
            this.taskSelectionLabel.toggle(selectable)
            this._updateSelectionLabel(selectable)
        })

        this.onStatePropertyChanged('canReopenProject', (canReopenProject) => {
            this.statusButton.setState({
                canReopenProject
            })
        })

        this.onStatePropertyChanged('isBTYEnabled', (enabled) => {
            this.$typeOfWorkSection.toggle(enabled)
        })

        this.onStatePropertyChanged('isESTEnabled', (enabled) => {
            this.$estimateSection.toggle(enabled)
        })

        this.onStatePropertyChanged('columnsOrder', (columnsOrder) => {
            for (let column of Object.values(this.columnsMap)) {
                column.hide()
            }

            for (let i = 0; i < columnsOrder.length; ++i) {
                const columnKey = columnsOrder[i]
                this.columnsMap[columnKey].show().css('display', 'flex')
                this.columnsMap[columnKey].css('order', i.toString())
            }
        })
    }

    templateHtml() {
        return "<tr class='taskRow'>" +
               "  <td class='selection'></td>" +
               "  <td class='names'>" +
               "    <div class='taskRowCellWrapper'></div>" +
               "  </td>" +
               "  <td class='status'>" +
               "    <div class='taskRowCellWrapper'></div>" +
               "  </td>" +
               "  <td class='typeOfWork'>" +
               "    <div class='taskRowCellWrapper'></div>" +
               "  </td>" +
               "  <td class='estimate'>" +
               "    <div class='taskRowCellWrapper'></div>" +
               "  </td>" +
               "  <td class='spentTime'>" +
               "    <div class='taskRowCellWrapper'></div>" +
               "  </td>" +
               "  <td class='deadline'>" +
               "    <div class='taskRowCellWrapper'></div>" +
               "  </td>" +
               "  <td class='lastTrackingDate'>" +
               "    <div class='taskRowCellWrapper'>" +
               "      <span class='value'></span>" +
               "      <span class='na'><%-na%></span>" +
               "    </div>" +
               "  </td>" +
               "  <td class='creationDate'>" +
               "    <div class='taskRowCellWrapper'>" +
               "      <span class='value'></span>" +
               "    </div>" +
               "  </td>" +
               "</tr>"
    }

    messageKeys() {
        return {
            na: 'common.not_available',
        }
    }

    afterRender() {
        this.$selection = this.find(".selection")
        this.taskSelectionLabel = new TaskSelectionLabel(this.$selection, true).init()
        this.taskSelectionLabel.on("change", (e, isSelected) => this.setClickSelection(isSelected))

        this.$namesCell = this.find("td.names .taskRowCellWrapper")
        this.$lastTrackingDate = this.find("td.lastTrackingDate .value")
        this.$creationDate = this.find("td.creationDate .value")
        this.$deadlineCell = this.find("td.deadline .taskRowCellWrapper")
        this.$estimateColumn = this.find("td.estimate .taskRowCellWrapper")
        this.$spentTimeColumn = this.find("td.spentTime .taskRowCellWrapper")
        this.$statusButton = this.find("td.status .taskRowCellWrapper")
        this.$typeOfWork = this.find("td.typeOfWork .taskRowCellWrapper")

        this.$estimateSection = this.find("td.estimate")
        this.$typeOfWorkSection = this.find("td.typeOfWork")

        const $tasksTableVerticalScrollContainer = $('.tasksTableVerticalScrollContainer')

        this.columnsMap = {
            [TaskSortBy.ESTIMATE]: this.find("td.estimate"),
            [TaskSortBy.DEADLINE]: this.find("td.deadline"),
            [TaskSortBy.CREATION_DATE]: this.find("td.creationDate"),
            [TaskSortBy.LAST_TRACKING_DATE]: this.find("td.lastTrackingDate"),
            [TaskSortBy.SPENT_TIME]: this.find("td.spentTime"),
            [TaskSortBy.TYPE_OF_WORK]: this.find("td.typeOfWork"),
        }

        this.namesCell = new NamesCell({
            tokensHighlighter: this.tokensHighlighter,
        }).init(this.$namesCell)

        this.$namesCell.click((e) => {
            setEventPreventHidingEditTaskSlidingPanel(e)
            this.actions.openTaskPanel(this.taskId)
        })

        let canEdit = this.state.canEdit

        this.editable = canEdit
        this._updateSelectionLabel(this.state.selectable)

        this.statusButton = new TaskStatusButton({
            editable: true,
            showStatusTypePrefix: false,
            positionParams: {
                offset: "0px 1px",
                within: $tasksTableVerticalScrollContainer,
                collision: 'fit',
            },
            onShowMenu: () => this.toggleClassMenuOpen(true),
            onHideMenu: () => this.toggleClassMenuOpen(false),
            taskStatusMenu: this.taskStatusMenu,
            onStatusChangedCb: (statusId) => {
                this._startUpdating(true)
                $(document).trigger("taskManagement_tasksTable_taskRow_statusChange", {
                    taskId: this.taskId,
                    workflowStatusId: statusId
                })
            },
        }).init(this.$statusButton)

        this.typeOfWorkEditor = new TypeOfWorkButton({
            showCategory: false,
            onShowMenu: () => this.toggleClassMenuOpen(true),
            onHideMenu: () => this.toggleClassMenuOpen(false),
            typeOfWorkMenu: this.typeOfWorkMenu,
            positionParams: {
                offset: "0px 1px",
                within: $tasksTableVerticalScrollContainer,
                collision: 'fit',
            },
            onTypeOfWorkChangedCb: (typeOfWorkId) => {
                this._startUpdating(true)
                $(document).trigger("taskManagement_tasksTable_taskRow_typeOfWorkChange", {
                    taskId: this.taskId,
                    typeOfWorkId: typeOfWorkId
                })
            },
        }).init(this.$typeOfWork)

        this.estimateEditor = new TimeEditor(
            this.$estimateColumn,
            canEdit,
            messageResource.getMessage('task.time_editor_placeholder.enter_hours'),
            messageResource.getMessage('task.time_editor_placeholder.not_defined')
        ).init()
        this.estimateEditor.on("change", (e, time) => {
            this._startUpdating(true)
            this.estimatedTime = time
            $(document).trigger("taskManagement_tasksTable_taskRow_estimateChange", {
                taskId: this.taskId,
                estimatedTime: time
            })
        })

        this.spentTimeCell = new TimeEditor(null, false).init(this.$spentTimeColumn)

        this.deadlineEditor = new TaskManagementDeadlineEditor(this.$deadlineCell, canEdit, dateFormat).init()

        const datePickerMenu = new DatePickerMenu({
            scheduleCalculator: new CorporateScheduleCalculator().init(window.invertedDaysDateMap, window.SystemSettings.defaultWorkSchedule),
            parentEl: this.find('td.deadline')[0],
            addClassesStr: 'taskRowDeadlineEditor',
            showMenuCb: () => this.toggleClassMenuOpen(true),
            hideMenuCb: () => this.toggleClassMenuOpen(false),
        }).init()

        this.deadlineEditor.setDataPickerMenu(datePickerMenu)

        this.deadlineEditor.on("change", (e, date) => {
            this._startUpdating(true)
            // TODO bakharev: look carefully
            this.deadline = date
            $(document).trigger("taskManagement_tasksTable_taskRow_deadlineChange", {
                taskId: this.taskId,
                deadline: date
            })
        })

        this.renderInitialState()
    }

    toggleClassMenuOpen(switcher) {
        this.$el.toggleClass('menuOpen', switcher)
    }

    setClickSelection(isSelected) {
        $(document).trigger("taskManagement_taskTable_taskRow_selectionChange", {
            taskId: this.taskId,
            isSelected: isSelected
        })
    }

    setSelection(isSelected) {
        this.taskSelectionLabel.setSelection(isSelected)
    }

    _updateSelectionLabel(selectable) {
        this.$selection.toggle(selectable)
    }

    static getSubtitle(projectName, customerName, singleCPSelection) {
        let subtitle = ""
        let customerEscapedName = escapeHtmlSymbols(customerName)
        let projectEscapedName = escapeHtmlSymbols(projectName)
        if (!singleCPSelection.customerId && !singleCPSelection.projectId)
            subtitle = customerEscapedName + TaskRow.getArrowImg() + projectEscapedName
        else if (!singleCPSelection.projectId)
            subtitle = projectEscapedName
        return subtitle
    }

    static getSubtitleTooltip(projectName, customerName, singleCPSelection) {
        let tooltip = ""
        if (!singleCPSelection.customerId && !singleCPSelection.projectId)
            tooltip = customerName + " > " + projectName
        else if (!singleCPSelection.projectId)
            tooltip = projectName

        return tooltip
    }

    static getArrowImg() {
        return "<img src='" + atImgPath('taskManagement/arrow.png') + "'/>"
    }

    update() {
        const task = TaskStore.get(this.taskId)
        const projectName = ProjectStore.get(task.projectId).name
        const customerName = CustomerStore.get(task.customerId).name
        this.setState({
            ...task,
            taskName: task.name,
            projectName: projectName,
            customerName: customerName,
        })
    }

    setEditable(editable) {
        this.estimateEditor.setEditable(editable)
        this.deadlineEditor.setEditable(editable)
        this.taskSelectionLabel.setEditable(editable)
    }

    // TODO: rename, too abstract name, may be startDataUpdating or startEntityUpdating
    _startUpdating(disable) {
        if (this.updating)
            return

        const setDisabled = (disabled) => {
            this.$el.toggleClass("disabled", disabled)
            this.statusButton.setDisabled(disabled)
            this.estimateEditor.setDisabled(disabled)
            this.deadlineEditor.setDisabled(disabled)
            this.typeOfWorkEditor.setDisabled(disabled)
            this.taskSelectionLabel.setDisabled(disabled)
        }

        this.updating = true
        if (disable) {
            setDisabled(true)
        }

        let handler = (e, taskId) => {
            if (this.taskId === taskId) {
                this.updating = false
                setDisabled(false)
                // TODO bakharev: set state was here
                this.update()
                $(document).off(e, handler)
            }
        }
        $(document).on("taskManagement_taskUpdated", handler)
    }

    startEditing() {
        if (this.inEdit)
            return

        this.inEdit = true
        this.$el.addClass("inEdit")
    }

    stopEditing() {
        this.inEdit = false
        this.$el.removeClass("inEdit")
        // TODO bakharev: set state was here
        this.update()
    }

    fadeOut() {
        this.$el.atAnimation().fadeOut()
        this._hidden = true
    }

    isHidden() {
        return this._hidden === true
    }

    _updateTypeOfWork(typeOfWorkId) {
        this.typeOfWorkEditor.setState({
            typeOfWorkId: typeOfWorkId,
            // TODO bakharev: change to normal code
            typeOfWorkName: unsafe_selectWithState((state) => getTypeOfWork(state, typeOfWorkId)).name,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/TaskRow.js